module.exports = __webpack_public_path__ + "static/media/sopt10kz.08f96a7e.pdf";